import React from "react";
import { Panel, PanelType, PrimaryButton, DefaultButton, Toggle } from "@fluentui/react";
import CustomerTypeFilter from "@/ui-controls/CustomerTypeFilter";

export interface CustomerFilterPanelProps {
  isOpen: boolean;
  onDismiss: () => void;
  selectedCustomerTypes: string[];
  onCustomerTypeChange: (selectedTypes: string[]) => void;
  selectedStatus: "active" | "inactive";
  onStatusChange: (status: "active" | "inactive") => void;
  onApplyFilters: () => void;
  onClearFilters: () => void;
}

const CustomerFilterPanel: React.FC<CustomerFilterPanelProps> = ({
  isOpen,
  onDismiss,
  selectedCustomerTypes,
  onCustomerTypeChange,
  selectedStatus,
  onStatusChange,
  onApplyFilters,
  onClearFilters,
}) => {
  const handleApply = () => {
    onApplyFilters();
    onDismiss();
  };

  const handleClear = () => {
    onClearFilters();
    onDismiss();
  };

  const hasActiveFilters =
    selectedCustomerTypes.length > 0 || selectedStatus !== "active";

  return (
    <Panel
      headerText="Filter Customers"
      isOpen={isOpen}
      onDismiss={onDismiss}
      type={PanelType.smallFixedFar}
      closeButtonAriaLabel="Close filter panel"
      isLightDismiss={true}
    >
      <div style={{ padding: "20px 0" }}>
        <div style={{ marginBottom: "20px" }}>
          <Toggle
            label="Status"
            inlineLabel
            onText="Inactive"
            offText="Active"
            checked={selectedStatus === "inactive"}
            onChange={(_, checked) => onStatusChange(checked ? "inactive" : "active")}
          />
        </div>
        <div style={{ marginBottom: "20px" }}>
          <h4 style={{ marginBottom: "10px", color: "#323130" }}>Customer Type</h4>
          <CustomerTypeFilter
            selectedTypes={selectedCustomerTypes}
            onSelectionChange={onCustomerTypeChange}
          />
        </div>

        <div style={{ 
          display: "flex", 
          gap: "8px", 
          marginTop: "30px",
          paddingTop: "20px",
          borderTop: "1px solid #edebe9"
        }}>
          <PrimaryButton
            text="Apply Filters"
            onClick={handleApply}
            disabled={!hasActiveFilters}
          />
          <DefaultButton
            text="Clear All"
            onClick={handleClear}
            disabled={!hasActiveFilters}
          />
        </div>

        {hasActiveFilters && (
          <div style={{ 
            marginTop: "15px", 
            fontSize: "12px", 
            color: "#605e5c" 
          }}>
            Active filters: {selectedCustomerTypes.length} customer type(s)
          </div>
        )}
      </div>
    </Panel>
  );
};

export default CustomerFilterPanel;
